import { render, staticRenderFns } from "./ReportTrends.vue?vue&type=template&id=657e3c90&scoped=true"
import script from "./ReportTrends.vue?vue&type=script&lang=js"
export * from "./ReportTrends.vue?vue&type=script&lang=js"
import style0 from "./ReportTrends.vue?vue&type=style&index=0&id=657e3c90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657e3c90",
  null
  
)

export default component.exports